module.exports = function MDecimal(val, scale) {
    var self = this;
    
    if (val !== undefined && typeof val !== "number") {
        throw new Error('Decimal metadata must be given a numeric default value');
    }
    
    if (scale !== undefined && typeof scale !== "number") {
        throw new Error('Decimal metadata must be given a numeric scale');
    }
    
    this.value = val || 0.00;
    
    if (scale === undefined) {
        var str = this.value + '', i = str.indexOf('.');
        this.scale = i > -1 ? str.length - (i + 1) : 2; 
    } else {
        this.scale = scale;
    }
    
    this.getDetails = function() {
        return {
            type : 'decimalString',
            name : 'decimalString',
            default : self.value,
            scale : self.scale
        };
    };
    
    this.parse = function(buffer) {
        var str = buffer.toString(), i = str.indexOf('.');
        return +str.substr(0, i + this.scale + 1);
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/metadata/decimal.js
// module id = 284
// module chunks = 1